module.exports = __webpack_public_path__ + "static/img/5.f20b73b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/eng/5.png
// module id = lVGk
// module chunks = 0